/** @griffel:css-start [d] null **/
.f10pi13n{position:relative;}
.ftuwxu6{display:inline-flex;}
.fi64zpg{flex-shrink:0;}
.f2znb4n{outline-width:2px;}
.f1yog68k{outline-style:solid;}
.fcvzvvt{outline-color:var(--colorNeutralBackground1);}
.f1euv43f{position:absolute;}
.f12fkyep{inset-block-start:-4px;}
.f1gn2l62{inset-inline-end:-4px;}
.fwoxyjy{box-shadow:0 0 0 2px var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1vpmtir{inset-block-start:-8px;}
.f4jzno9{inset-inline-end:-10px;}
/** @griffel:css-end **/